import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import "./containers/customLayout.css"

import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { BrowserRouter } from "react-router-dom";
import { initKeycloak } from "@seims/shared/src/security";
import {Offline, ReactQueryProvider } from "@seims/shared";

const root = ReactDOM.createRoot(document.getElementById("root"));
let failedStart = false;
let message;
const startApp = () => {
  initKeycloak(renderApp).then((instance) => {
    failedStart = instance.failedToStart;
    if (failedStart) {
      message = "One of the application services failed to start. Please contact administrator";
      return renderApp(true);
    } else renderApp(false);
  });
};

const renderApp = () => {
  root.render(
    // <React.StrictMode>
    <BrowserRouter>
      <Offline />
      <ReactQueryProvider>
        <App failedStart={failedStart} message={message} />
      </ReactQueryProvider>
    </BrowserRouter>
    // </React.StrictMode>
  );

  // If you want to start measuring performance in your app, pass a function
  // to log results (for example: reportWebVitals(console.log))
  // or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
  reportWebVitals();

  //http.setJWT();
  //HttpService.configure();
};

startApp();
